import React, { Component } from 'react'
import XMLViewer from "react-xml-viewer";
import { withRouter } from "react-router";
import API from "./apiCalls/accountAPI";
import { Segment, Dimmer } from 'semantic-ui-react';
import { SquareLoader } from "kx-common-components";

const customTheme = {
    attributeKeyColor: "#0074D9",
    attributeValueColor: "#2ECC40",
  };

class XmlReviewer extends Component {

   constructor(props){
      super(props);
      this.state = {
         match:  props.match,
         resLoader: null,
         xmlResponse: null,
         reqLoader: null,
         xmlRequest: null
         
      }
   }
  

  componentDidMount(props){
    const { shipId, formType } = this.state.match.params;  
    this.setState({"resLoader": true});
    document.title = `Klearnow | ${shipId} | ${formType}`;
    API.xmlReviewByShipId(shipId, formType).then((res)=>{
      this.setState({"xmlResponse": res.data.eventMessage.payload},()=>{
         this.setState({"resLoader": false, "reqLoader": true});
      })
    }) 
  }
  
  render() {
    return (
            <div className="topDiv">
                <div style={{"padding": "10px", "width": "100%", "height": "100vh"}}>
                <table style={{"border": "1px solid #000",  "width": "100%"}}>
                <tr style={{"background": "#fff", "border": "1px solid #000"}}>
                    <td style={{"textAlign": "center"}}><b>XML REVIEW</b></td>
                </tr>
                    <tr>
                    <td style={{"maxWidth":"97vh", "maxHeight": "97vh", "overflow":"scroll"}}>
                    {
                    this.state.resLoader && !this.state.xmlResponse? (
                        <Segment className="page-loader-xml">
                        <Dimmer active inverted>
                            <SquareLoader
                            color1={"#1fa2ff"}
                            color2={"#12d8fa"}
                            color3={"#06ffcb"}
                            string={"Preparing Preview Xml"}
                            />
                        </Dimmer>
                        </Segment>) :  
                        <XMLViewer xml={this.state.xmlResponse} theme={customTheme} />
                    }
                    </td>
                </tr>
                </table>  
                
                </div>
            </div>
        );
    }
}
export const XmlReviewerWithRouter = withRouter(XmlReviewer);
